<template>
  <div
    ref="container"
    @click="$emit('click')"
    style="height: 100%; width: 100%; background-color: white"
    @resize="reDraw"
  >
    <canvas v-if="!full" :width="imgWidth" :height="imgHeight" ref="image" />
    <img
      v-else
      :src="imgSrc"
      :width="imgWidth"
      alt
      @load="$emit('setLocation')"
    />
  </div>
</template>

<script>
import { getImageObject, getImageAsDataUrl } from "@/services/bookData.js";
import Vue from "vue";
export default {
  data() {
    return {
      img: null,
      imgSrc: "",
      headerTop: 0,
      headerLeft: 0,
      timer: null,
      imgWidth: 0,
      imgHeight: 0,
    };
  },
  props: ["currentHeaderData", "book", "delay", "resize", "full"],
  mounted() {
    const _this = this;
    Vue.nextTick(() => {
      _this.imgWidth = _this.$el.clientWidth;
      _this.imgHeight = Math.min(_this.imgWidth / 10, 200);
      _this.$emit("resize", _this.imgHeight);
      _this.enterItem();
    });
  },
  destroyed() {
    this.img = null;
  },
  watch: {
    currentHeaderData: function (val, ov) {
      if (ov.pageId == val.pageId) return;
      this.reEnterItem();
    },
    book: function (val, ov) {
      if (ov == val) return;
      this.reEnterItem();
    },
    resize: function (val) {
      this.reDraw();
    },
  },
  methods: {
    reDraw() {
      Vue.nextTick(() => {
        this.imgWidth = this.$el.clientWidth;
        this.imgHeight = Math.min(this.imgWidth / 10, 200);
        this.$emit("resize", this.imgHeight);
        this.draw();
      });
    },
    enterItem() {
      let _t = this;
      let timeout = this.delay ? 400 : 0;
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        await this.getHeader();
        Vue.nextTick(() => {
          _t.draw();
        });
      }, timeout);
    },
    reEnterItem() {
      clearTimeout(this.timer);
      this.img = null;
      this.enterItem();
    },
    leaveItem() {
      clearTimeout(this.timer);
    },
    async getHeader() {
      if (this.img) return;

      await this.getImg({ resize: 750, zoom: 50 });
    },
    async goToPage() {
      this.$emit("click", this.id);
    },
    async getImg(cropRect) {
      if (this.full) {
        try {
          let imageData = await getImageAsDataUrl(
            this.book,
            this.currentHeaderData.pageId,
            cropRect,
            null,
            this.currentHeaderData.pos
          );

          this.imgSrc = imageData;
        } catch (ex) {
          console.error("header error>>", ex);
        }
      } else {
        try {
          let img;
          try {
            img = await getImageObject(
              this.book,
              this.currentHeaderData.pageId,
              "image",
              false,
              cropRect,
              null,
              this.currentHeaderData.pos
            );
          } catch (ex) {
            console.error("header error>>", ex);
          }

          this.img = img;
        } catch (ex) {
          console.error("header error>>", ex);
        }
      }
    },
    draw() {
      if (!this.img) return;

      let canvas = this.$refs.image;
      if (canvas == undefined) return;
      let canvasCtx = canvas.getContext("2d");

      let img = this.img.picture;
      let imageMetaData = this.img.imageMetaData;
      let originWidth =
        imageMetaData.width && imageMetaData.width != 0
          ? imageMetaData.width
          : this.img.width;
      let originHeight =
        imageMetaData.height && imageMetaData.height != 0
          ? imageMetaData.height
          : this.img.height;

      if (this.full) {
        this.imgHeight = this.imgWidth * (originHeight / originWidth);
        this.$emit("setHeight", this.imgHeight);
      }

      this.$nextTick(() => {
        let marginTop = imageMetaData.top;
        let originImgRatio = originWidth / originHeight;

        let canvasWRatio = canvas.width / originWidth;
        let canvasFullHeight = originHeight * canvasWRatio;
        let canvasHRatio = canvasFullHeight / originHeight;

        let w;
        let h;
        let top = 0,
          ctop = 0;
        let height = (canvas.height / canvasFullHeight) * originHeight;

        let canvasRat = canvas.width / this.img.width;
        let fullHeight = this.img.height * canvasRat;
        let partRat = canvas.height / fullHeight;

        height = canvas.height / canvasRat;

        canvasCtx.fillStyle = "white";
        canvasCtx.fillRect(0, 0, canvas.width, canvas.height);

        canvasCtx.drawImage(
          img,
          0,
          0,
          img.width,
          this.full ? img.height : height,
          1,
          1,
          canvas.width,
          canvas.height
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  text-align: right;
}
.header-container {
  width: 502px;
  height: 52px;
  border: 1px solid black;
  position: absolute;
  z-index: 9999999;
}
</style>
